import type { Initiative as InitiativeType } from "@nnf3d/studio/types";
import { PortableText } from "@portabletext/react";

import type { VoidComponent } from "../../lib/types";
import { components } from "../initiative-blocks/components";

const Initiative: VoidComponent<InitiativeType> = (props) => (
	<li className="relative overflow-hidden border-t border-stroke-muted py-3 after:absolute after:-top-px after:left-0 after:h-px after:w-full after:transform-[translateX(-100%)] after:bg-accent after:transition-transform after:duration-300 after:ease-in-out hover:text-foreground hover:after:transform-[translateX(0%)]">
		<div className="before flex gap-12 before:block before:w-12 before:text-right before:text-xl before:counter-dot">
			<div className="mb-10">
				<h3 className="mb-(--text-xl--line-height) text-xl text-foreground">{props.title}</h3>

				<PortableText value={props.content} components={components} />
			</div>
		</div>
	</li>
);

export { Initiative };
